import React, { createContext, useCallback, useContext } from 'react';
import { useDispatch } from 'react-redux';
import InsufficientPermissionModal from '../components/InsufficientPermissionModal';
import { showInsufficientPermissionModal } from '../store/permissionModalSlice';

const PermissionModalContext = createContext(null);

export function PermissionModalProvider({ children }) {
  const dispatch = useDispatch();

  const showModal = useCallback(() => {
    dispatch(showInsufficientPermissionModal());
  }, [dispatch]);

  return (
    <PermissionModalContext.Provider value={{ showInsufficientPermissionModal: showModal }}>
      {children}
      <InsufficientPermissionModal />
    </PermissionModalContext.Provider>
  );
}

export function usePermissionModal() {
  const context = useContext(PermissionModalContext);

  if (!context) {
    throw new Error('usePermissionModal must be used within PermissionModalProvider');
  }

  return context;
}
